import { useEffect, useState } from "react";
import { CONSENT_EVENT, getConsent, setConsent } from "@/analytics/ga4";

// Reusable analytics preference toggle (Settings page + footer dialog).
export const AnalyticsPreference = ({ dark = false }) => {
  const [choice, setChoice] = useState(() => getConsent());

  useEffect(() => {
    const onChange = () => setChoice(getConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  const label = choice === "granted" ? "Analytics enabled" : choice === "denied" ? "Analytics disabled" : "No choice made yet";
  const muted = dark ? "text-ivory-200/70" : "text-muted-foreground";
  const border = dark ? "border-ivory-200/30 text-ivory-50 hover:border-gold-500" : "border-border text-navy-900 hover:border-gold-500";

  return (
    <div data-testid="analytics-preference">
      <p className={`text-sm ${muted}`}>
        Essential cookies (sign-in, security) are always on. Optional analytics (Google Analytics 4, no advertising) is{" "}
        <strong data-testid="analytics-preference-status">{label}</strong>.
      </p>
      <div className="mt-3 flex gap-2">
        <button
          onClick={() => setConsent("granted")}
          disabled={choice === "granted"}
          className={`px-3 py-1.5 text-xs rounded-sm border ${border} disabled:opacity-50`}
          data-testid="analytics-preference-enable"
        >
          Enable analytics
        </button>
        <button
          onClick={() => setConsent("denied")}
          disabled={choice === "denied"}
          className={`px-3 py-1.5 text-xs rounded-sm border ${border} disabled:opacity-50`}
          data-testid="analytics-preference-disable"
        >
          Disable analytics
        </button>
      </div>
    </div>
  );
};
